module.exports = __webpack_public_path__ + "static/media/dustyunknown.76bb15b9.svg";